
    
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"confirmSessionAuthy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authyCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmSessionAuthy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"authyCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authyCode"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionFragment"},"directives":[]}]}}]}}]};
  

    var useUnique = require('@graphql-tools/webpack-loader-runtime').useUnique;
    var unique = useUnique();
  doc.definitions = doc.definitions.concat(unique(require("../../fragments/users/SessionFragment.gql").definitions));


    module.exports = doc
  
